export default {
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Début"])}
}